// @flow

export const SHOW_CONFIG_VALIDATION_ERRORS: 'configValidationErrors' = 'configValidationErrors';

export default null;
